import React from 'react'

export const ChipIconTimes = () => (
  <svg
    width='11'
    height='11'
    viewBox='0 0 9 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.49297 7.88204C8.83477 8.22383 8.83477 8.77754 8.49297 9.11934C8.32344 9.29024 8.09922 9.375 7.875 9.375C7.65078 9.375 7.42711 9.28955 7.25648 9.11866L4.375 6.23868L1.49379 9.11797C1.32289 9.29024 1.09895 9.375 0.875 9.375C0.651055 9.375 0.427383 9.29024 0.256348 9.11797C-0.0854492 8.77618 -0.0854492 8.22247 0.256348 7.88067L3.13838 4.99864L0.256348 2.11798C-0.0854492 1.77618 -0.0854492 1.22247 0.256348 0.880676C0.598144 0.538879 1.15186 0.538879 1.49365 0.880676L4.375 3.76407L7.25703 0.882043C7.59883 0.540247 8.15254 0.540247 8.49434 0.882043C8.83613 1.22384 8.83613 1.77755 8.49434 2.11935L5.6123 5.00137L8.49297 7.88204Z'
      fill='currentColor'
    />
  </svg>
)

export const ChipIconPencil = () => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.37273 8.10245L8.50078 0.973231C9.08672 0.387341 10.0383 0.387341 10.6242 0.973231L11.5477 1.89737C11.6203 1.9705 11.6836 2.04948 11.7399 2.13268C12.1242 2.71487 12.0609 3.50636 11.5477 4.01964L4.41797 11.147C4.3875 11.1774 4.35703 11.1868 4.32422 11.236C4.09922 11.4353 3.83203 11.5618 3.5414 11.6673L0.721167 12.497C0.523823 12.5556 0.310308 12.5017 0.16476 12.3353C0.0192088 12.211 -0.0352085 11.9978 0.0228697 11.7985L0.852417 8.97901C0.949918 8.64854 1.12875 8.3462 1.37273 8.10245ZM1.93172 9.29542L1.39312 11.1282L3.225 10.5892C3.3539 10.5446 3.51094 10.4626 3.62344 10.3524L8.97657 4.99698L7.50235 3.52276L2.1682 8.89698C2.15437 8.91104 2.14101 8.92511 2.12812 8.94151C2.03765 9.04229 1.97039 9.16417 1.93172 9.29542Z'
      fill='currentColor'
    />
  </svg>
)

export const ChipIconOpenNew = () => (
  <svg
    width='11'
    height='11'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9 7.5C8.58586 7.5 8.25 7.83586 8.25 8.25V10.5H1.5V3.75H3.75C4.16414 3.75 4.5 3.41438 4.5 3C4.5 2.58562 4.16414 2.25 3.75 2.25H1.5C0.671484 2.25 0 2.92148 0 3.75V10.5C0 11.3283 0.671484 12 1.5 12H8.25C9.07852 12 9.75 11.3283 9.75 10.5V8.25C9.75 7.83516 9.41484 7.5 9 7.5ZM11.4375 0H8.25C7.94672 0 7.67297 0.182742 7.55719 0.462891C7.44073 0.743438 7.50518 1.0657 7.7198 1.28039L8.69062 2.25L3.97031 6.97031C3.67734 7.26328 3.67734 7.73789 3.97031 8.03086C4.11562 8.17734 4.30781 8.25 4.5 8.25C4.69219 8.25 4.88391 8.17676 5.03016 8.03027L9.75 3.31172L10.7198 4.28156C10.9344 4.4958 11.2561 4.55906 11.5373 4.44417C11.8172 4.32656 12 4.05234 12 3.75V0.5625C12 0.251719 11.7492 0 11.4375 0Z'
      fill='currentColor'
    />
  </svg>
)

export const ChipIconInfo = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.78125 0.21875C3.03633 0.21875 0 3.25618 0 7C0 10.746 3.03633 13.7812 6.78125 13.7812C10.5262 13.7812 13.5625 10.746 13.5625 7C13.5625 3.25618 10.5262 0.21875 6.78125 0.21875ZM6.78125 12.4688C3.75889 12.4688 1.3125 10.0234 1.3125 7C1.3125 3.97865 3.759 1.53125 6.78125 1.53125C9.80249 1.53125 12.25 3.97772 12.25 7C12.25 10.0223 9.80462 12.4688 6.78125 12.4688ZM6.78125 3.22656C7.41552 3.22656 7.92969 3.74073 7.92969 4.375C7.92969 5.00927 7.41552 5.52344 6.78125 5.52344C6.14698 5.52344 5.63281 5.00927 5.63281 4.375C5.63281 3.74073 6.14698 3.22656 6.78125 3.22656ZM8.3125 10.1719C8.3125 10.3531 8.16558 10.5 7.98438 10.5H5.57812C5.39692 10.5 5.25 10.3531 5.25 10.1719V9.51562C5.25 9.33442 5.39692 9.1875 5.57812 9.1875H5.90625V7.4375H5.57812C5.39692 7.4375 5.25 7.29058 5.25 7.10938V6.45312C5.25 6.27192 5.39692 6.125 5.57812 6.125H7.32812C7.50933 6.125 7.65625 6.27192 7.65625 6.45312V9.1875H7.98438C8.16558 9.1875 8.3125 9.33442 8.3125 9.51562V10.1719Z'
      fill='currentColor'
    />
  </svg>
)

export const ChipIconPreview = () => (
  <svg
    width='18'
    height='14'
    viewBox='0 0 18 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.9375 0.4375C6.57031 0.4375 4.6748 1.51562 3.29492 2.79883C1.92383 4.07031 1.00684 5.59375 0.573242 6.63965C0.476562 6.87109 0.476562 7.12891 0.573242 7.36035C1.00684 8.40625 1.92383 9.92969 3.29492 11.2012C4.6748 12.4844 6.57031 13.5625 8.9375 13.5625C11.3047 13.5625 13.2002 12.4844 14.5801 11.2012C15.9512 9.92676 16.8682 8.40625 17.3047 7.36035C17.4014 7.12891 17.4014 6.87109 17.3047 6.63965C16.8682 5.59375 15.9512 4.07031 14.5801 2.79883C13.2002 1.51562 11.3047 0.4375 8.9375 0.4375ZM13.1562 7C13.1562 9.3291 11.2666 11.2188 8.9375 11.2188C6.6084 11.2188 4.71875 9.3291 4.71875 7C4.71875 4.6709 6.6084 2.78125 8.9375 2.78125C11.2666 2.78125 13.1562 4.6709 13.1562 7ZM8.9375 5.125C8.9375 6.15918 8.09668 7 7.0625 7C6.72559 7 6.40918 6.91211 6.13672 6.75391C6.13086 6.83594 6.125 6.91504 6.125 7C6.125 8.55273 7.38477 9.8125 8.9375 9.8125C10.4902 9.8125 11.75 8.55273 11.75 7C11.75 5.44727 10.4902 4.1875 8.9375 4.1875C8.85547 4.1875 8.77344 4.19043 8.69141 4.19922C8.84668 4.47168 8.9375 4.78809 8.9375 5.125Z'
      fill='currentColor'
    />
  </svg>
)
